import React, { Component } from 'react'
import { Navigate } from 'react-router-dom';
import {app, appDatabasePrimaryFunctions} from '../../base';
import logoImage from '../../styles/images/sqwad-hand.png';
import logoWithTextImageBlack from '../../styles/images/new_sqwad_logo.png';
import '../../styles/css/main.css';
import Swal from 'sweetalert2';

class AdminLogin extends Component {
    constructor(props) {
        super(props);
        this.authWithEmailPassword = this.authWithEmailPassword.bind(this);
        this.state = {
          loading: true,
          redirect: false
        };
    }

    authWithEmailPassword(event) {
      event.preventDefault();
      const email = this.emailInput.value;
      const password = this.passwordInput.value;
      if(!email || !password){
          Swal.fire({
              title: 'Missing Info',
              text: "Please enter both a password and email",
              type: 'warning',
              confirmButtonText: 'Ok'
          })
          return
      }
      this.setState({loading:true});
      app.auth().fetchSignInMethodsForEmail(email)
      .then((providers) => {
        this.setState({loading:false});
        if (providers.indexOf("password") === -1) {
            // they used facebook
            this.loginForm.reset();
            Swal.fire({
                title: 'Uh Oh',
                text: "Looks like you used a different sign in method last time.",
                type: 'warning',
                confirmButtonText: 'Ok'
              })
          } else {
            // sign user in
            return app.auth().signInWithEmailAndPassword(email, password)
          }
        }, this)
        .then(async (user) => {
          if (user) {
              let allowedToSignIn = true;
              try {
               await appDatabasePrimaryFunctions.ref('userImage').orderByChild('image_url').limitToFirst(1).once('value');
              } catch (e) {
                  allowedToSignIn = false;
                  Swal.fire({
                      title: 'Uh Oh',
                      text: "You dont have permission to sign in, if you think this is a mistake, talk to Sqwad",
                      type: 'warning',
                      confirmButtonText: 'Ok'
                  })
              }
            if(!allowedToSignIn){
                app.auth().signOut();
                return;
            }
            // this.loginForm.reset();
            // this.props.setCurrentUser(user);
            // this.setState({
            //   redirect: true,
            // })
          } else {
            Swal.fire({
                title: 'Wrong credentials',
                text: "Check your email and password and try again!",
                type: 'warning',
                confirmButtonText: 'Ok'
              })
          }
        })
        .catch((error) => {
            console.log(error)
          this.setState({
            loading: false,
          });
          Swal.fire({
              title: 'Uh oh!',
              text: error,
              type: 'error',
              confirmButtonText: 'Ok'
            })
        })
  }

    // Firebase Authentication sends the reset email itself — no email service
    // on our side. The admin's account is the same one the fan app uses, so the
    // new password applies to both.
    async sendPasswordReset() {
        if (this.state.loading) return;
        const email = (this.emailInput && this.emailInput.value || "").trim();
        if (!email) {
            Swal.fire({
                title: 'Enter your email',
                text: "Type the email you sign in with, then click Forgot password again.",
                icon: 'warning',
                confirmButtonText: 'Ok'
            })
            return;
        }
        this.setState({loading: true});
        try {
            await app.auth().sendPasswordResetEmail(email);
        } catch (error) {
            // Whether or not that email has an account, say the same thing —
            // the login page must not confirm which emails exist.
            if (!error || error.code !== 'auth/user-not-found') {
                this.setState({loading: false});
                Swal.fire({
                    title: 'Uh oh!',
                    text: (error && error.message) || 'Could not send the reset email. Try again in a moment.',
                    icon: 'error',
                    confirmButtonText: 'Ok'
                })
                return;
            }
        }
        this.setState({loading: false});
        Swal.fire({
            title: 'Check your email',
            text: "If " + email + " has an account, a password reset link is on its way.",
            icon: 'success',
            confirmButtonText: 'Ok'
        })
    }

    componentDidMount(){
        if (app.auth().currentUser) {
          this.setState({ redirect: true })
        }
        this.setState({
          loading: false
        })
    }

    render() {
        if (this.state.redirect === true || this.props.user) {
            return <Navigate to="/admin" />
        }
        return (
            <div className="auth-fluid">
              <div className="loading-screen" style={{display: this.state.loading ? 'block' : 'none' }}/>
              <div className="auth-fluid-form-box">
                <div className="align-items-center d-flex h-100">
                    <div className="card-body">

                        <div className="auth-brand">
                            <img src={logoWithTextImageBlack} alt="" height="auto" width="200px"/>
                        </div>

                        <h4 className="auth-title">Sign in</h4>
                        <p className="auth-sub">Use the email and password SQWAD set up for your club.</p>

                        <form onSubmit={(event) => { this.authWithEmailPassword(event) }} ref={(form) => { this.loginForm = form }} className="auth-form">
                            <div className="form-group">
                                <label htmlFor="emailaddress">Email address</label>
                                <input id="emailaddress" className="form-control" type="email" name="email" autoComplete="username" ref={(input) => { this.emailInput = input }} placeholder="you@club.com"/>
                            </div>
                            <div className="form-group">
                                <label htmlFor="password">Password</label>
                                <input id="password" className="form-control" name="password" type="password" autoComplete="current-password" ref={(input) => { this.passwordInput = input }} placeholder="Your password"/>
                            </div>
                            <button className="btn btn-primary auth-submit" type="submit">Sign in</button>
                            <button className="btn btn-link auth-forgot" type="button" onClick={() => this.sendPasswordReset()}>Forgot password?</button>
                        </form>

                    </div>
                </div>
            </div>

            <div className="auth-fluid-right text-center">
                <div className="auth-user-testimonial">
                    <p className="auth-tip-eyebrow">Tip of the month</p>
                    <p className="auth-tip-body">
                        Plug the emails you collect into Facebook, Instagram and Snapchat ads for
                        ticketing retargeting &mdash; clubs see 5&ndash;8&times; returns.
                    </p>
                    <img src={logoImage} width="140px" alt="" className="auth-tip-mark"/>
                </div>
            </div>
        </div>
        );
    }
}

export default AdminLogin
